import { Header } from "./components/header/header";
import { ContentResultList } from "./components/resultList/contentResultList";
import { Base } from "./resultsView.base";

export const ResultsView = Object.assign(Base, {
    Header: Header,
    ResultList: ContentResultList
});
